import Api, { xhrUpload } from "../index";
import ApiConstants, { AA } from "../ApiConstants";
import { customToast } from "../../utils/General";
export const detailsCompany = ({ data }) =>
  Api(
    ApiConstants.Company.Details,
    { CompanyIds: [Number(data.CompanyId)] },
  );

export const codalCompany = ({ data }) =>
  Api(
    ApiConstants.Company.Codal,
    { CompanyId: data.CompanyId, Type: data.Type },
  );

export const GetRemotePaper = (insCode) =>
  Api(
    ApiConstants.Init.GetRemoteConfigValue,
    {Key: `paperData_${insCode}`,JsonParse: true}
  );

export const tradesCompany = (CompanyId, DateFrom, DateTo) =>
  Api(
    ApiConstants.Company.Trades,
    {
      CompanyId,
      DateFrom,
      DateTo,
    }
  );

export async function updateCompany(
  Cover,
  Logo,
  params,
  token = null,
  method = "post"
) {
  let options;
  options = {
    headers: {
      ApiKey: `${AA}`,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    method,
    body: createFormData(Cover, Logo, params),
  };
  try {
    const r = await fetch(
      ApiConstants.BASE_URL + ApiConstants.Company.Update,
      options
    );
    const data = await r.json();
    console.log(">>> API Call Reqeust: >>>", {
      path: ApiConstants.Company.Update,
      options,
    });
    console.log("<<< API Call Response: <<<", data);
    if (data.code < 0) {
      customToast("error", data?.message?.pr);
    }
    return {
      status: r.status,
      ...data,
      message: data?.message?.pr || data?.message,
    };
  } catch (error) {
    return error;
  }
}

const createFormData = (Cover, Logo, body) => {
  const data = new FormData();
  data.append("Cover", Cover);
  data.append("Logo", Logo);
  Object.keys(body).forEach((key) => {
    data.append(key, body[key]);
  });
  return data;
};

export async function uploadCompanyUserStockTransactionData(
  UserStockTransactionData,
  token = null,
  onProgress = (p) => console.log("p", p),
  method = "post"
) {
  let formData = new FormData();
  formData.append("UserStockTransactionData", UserStockTransactionData);
  let options;
  options = {
    headers: {
      ApiKey: `${AA}`,
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    method,
    body: formData,
  };
  try {
    const r = await xhrUpload(
      ApiConstants.BASE_URL +
        ApiConstants.Company.UploadCompanyUserStockTransactionData,
      options,
      onProgress
    );
    const data = await JSON.parse(`${r}`);
    console.log(">>> API Call Reqeust: >>>", {
      path: ApiConstants.Company.UploadCompanyUserStockTransactionData,
      options,
    });
    console.log("<<< API Call Response: <<<", data);
    if (data.code < 0) {
      customToast("error", data?.message?.pr);
    }
    return {
      status: r.status,
      ...data,
      message: data?.message?.pr || data?.message,
    };
  } catch (error) {
    return error;
  }
}
